import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { useAddRealEstateLangCategoriesMutation, useDeleteRealEstateLangCategoriesMutation, useEditRealEstateLangCategoriesMutation } from "../../../../redux/api/handBooksApi/realEstateLangCategoriesApi";
import { getCookie } from "typescript-cookie";

const useRealEstateLangCategory = (modal: any, refresh?: () => void) => { 
    const { t } = useTranslation();
    const { confirm } = modal;
    const [addRealEstateLangCategory] = useAddRealEstateLangCategoriesMutation();  
    const [deleteRealEstateLangCategory] = useDeleteRealEstateLangCategoriesMutation(); 
    const [editRealEstateLangCategory] = useEditRealEstateLangCategoriesMutation(); 

    async function onAddRealEstateLangCategory(newRealEstateLangCategory: EntDirectoryInfoName): Promise<boolean> {  
        try {
            let status: boolean = false;
            await addRealEstateLangCategory(newRealEstateLangCategory).then((response: any) => {  
                   if (response.error) {
                                               const isKyrgyz = getCookie('i18next') === 'ky';
                                               const lang = isKyrgyz ? 'kg' : 'ru';
                                               const res = response.error.data?.res;
                                               const errorMessages = Array.isArray(res)
                                                   ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                   : response.error.data?.msg || t('unknownError'); 
                                               throw new Error(errorMessages);
                                           }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    async function onDeleteRealEstateLangCategory(realEstateLangCategory: EntDirectoryInfoName) {  
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteRealEstateLangCategory(realEstateLangCategory.id as number).then((response: any) => {  
                        if (response.error !== undefined && response.error.status === 400) {
                            status = false;
                            throw new Error(response.error.data.message);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                    });
                }
            })
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    async function onEditRealEstateLangCategory(editedRealEstateLangCategory: EntDirectoryInfoName): Promise<boolean> {  
        try {
            let status: boolean = false;
            await editRealEstateLangCategory(editedRealEstateLangCategory).then((response: any) => {  
                if (response.error) {
                                            const isKyrgyz = getCookie('i18next') === 'ky';
                                            const lang = isKyrgyz ? 'kg' : 'ru';
                                            const res = response.error.data?.res;
                                            const errorMessages = Array.isArray(res)
                                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                : response.error.data?.msg || t('unknownError'); 
                                            throw new Error(errorMessages);
                                        }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    return { onAddRealEstateLangCategory, onDeleteRealEstateLangCategory, onEditRealEstateLangCategory };  
}

export { useRealEstateLangCategory };  
